import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyFolderAndDocumentServices = {
  getStudyFolderAndDocument,
  addNewStudyFolderAndDocument,
  uploadStudyDocument,
  updateStudyFolderAndDocument,
  softDeleteRestoreStudyFolderAndDocument,
  deleteStudyFolderAndDocument
};

// Backward compatibility for older imports.
export const studyManagementServices = studyFolderAndDocumentServices;

// Add New Study
async function addNewStudyFolderAndDocument(userData) {
  const response = await fetch(
    `${config.API_URL}addNewStudyFolderAndDocument`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data;
}

// Update Study
async function updateStudyFolderAndDocument(userData) {
  const response = await fetch(
    `${config.API_URL}updateStudyFolderAndDocument`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Update Study
async function softDeleteRestoreStudyFolderAndDocument(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreStudyFolderAndDocument`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Delete Study
async function deleteStudyFolderAndDocument(userData) {
  const response = await fetch(
    `${config.API_URL}deleteStudyFolderAndDocument`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Get Study Folder/Document
async function getStudyFolderAndDocument(studyId, searchData, page, length, status = "all") {
  const query = new URLSearchParams();
  query.append("status", status || "all");
  query.append("search", searchData || "");

  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getStudyFolderAndDocument/${studyId}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function uploadStudyDocument(formData) {
  const token = localStorage.getItem("token");
  const requestHeaders = {
    authorization: token ? `Bearer ${token}` : "",
  };

  const response = await fetch(
    `${config.API_URL}addNewStudyFolderAndDocument`,
    {
      method: "POST",
      headers: requestHeaders,
      body: formData,
    }
  );

  const data = await response.json();
  // handleResponse(data);
  return data;
}